import { Animated, AnimatedProps } from 'react-animated-css';
import { ReactNode } from 'react';

interface AnimatedContainerProps extends AnimatedProps {
  children?: ReactNode;
}

const AnimatedContainer = (props: AnimatedContainerProps) => <Animated {...props} />;
export default AnimatedContainer;